import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const RemoveLangParam = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.has("lang")) {
      params.delete("lang");
      navigate(`${location.pathname}`, { replace: true });
    }
  }, [location, navigate]);

  return null;
};

export default RemoveLangParam;
